import { useEffect, useState, useCallback } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import Layout from '../components/Layout';
import ParallaxBanner from '../components/ParallaxBanner';
import contentService from '../services/contentService';
import featureFlags from '../utils/featureFlags';
import useContentUpdates from '../hooks/useContentUpdates';

function CheckoutCancel() {
  const [searchParams] = useSearchParams();

  // Get order info from URL params
  const orderId = searchParams.get('orderId') || searchParams.get('order_id');

  // Initialize scripts
  useEffect(() => {
    const handleWindowLoad = () => {
      if (window.$ && window.$('.loader1').length > 0) {
        window.$(".loader1").fadeOut(800);
        window.$('.side-menu').removeClass('hidden');
      }
    };

    if (document.readyState === 'complete') {
      handleWindowLoad();
    } else {
      window.addEventListener('load', handleWindowLoad);
    }

    if (window.WOW) {
      new window.WOW().init();
    }

    return () => {
      window.removeEventListener('load', handleWindowLoad);
    };
  }, []);


  const [backgroundUrl, setBackgroundUrl] = useState(null);

  const fetchBackground = useCallback(async () => {
    if (!featureFlags.useDynamicBackgrounds()) {
      return;
    }
    try {
      const result = await contentService.getPageBackground('product-listing');
      if (result.success && result.imageUrl) {
        setBackgroundUrl(result.imageUrl);
      }
    } catch (err) {
      console.error('[CheckoutCancel] Error fetching background:', err);
    }
  }, []);

  useEffect(() => {
    fetchBackground();
  }, [fetchBackground]);

  useContentUpdates({
    onPageBackgroundUpdated: (page) => {
      if (page === 'product-listing') {
        fetchBackground();
      }
    }
  });

  return (
    <Layout>
      {/* Parallax Banner */}
      {backgroundUrl && (
        <ParallaxBanner
          imageUrl={backgroundUrl}
          speed={0.6}
          offset={0}
          className="paralax-section-slide-data"
        />
      )}

      {/* Cancel Section */}
      <div className="about_content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center py-5">
              <div className="cancel-icon mb-4 wow fadeIn" data-wow-duration="1s">
                <i className="fas fa-times-circle" style={{
                  fontSize: '100px',
                  color: '#dc3545'
                }}></i>
              </div>
              <h1 className="heading mb-3 wow fadeIn" data-wow-duration="1.2s">Payment Cancelled</h1>
              <p className="para_text mb-4 wow fadeIn" data-wow-duration="1.4s">
                Your payment was cancelled. Don't worry - your cart items are still saved.
              </p>

              <div className="wow fadeIn" data-wow-duration="1.6s">
                <Link to="/checkout" className="btn pink-gradient-btn-into-black mr-3 mb-2">
                  <i className="fas fa-redo mr-2"></i>
                  Try Again
                </Link>
                <Link to="/shop-cart" className="btn btn-outline-secondary mb-2">
                  <i className="fas fa-shopping-cart mr-2"></i>
                  View Cart
                </Link>
              </div>

              <div className="alert alert-info mt-5 wow fadeIn" data-wow-duration="1.8s" style={{ maxWidth: '600px', margin: '0 auto' }}>
                <h5 className="alert-heading">
                  <i className="fas fa-info-circle mr-2"></i>
                  Need Help?
                </h5>
                <p className="mb-0">
                  If you experienced any issues during checkout, please <Link to="/contact">contact us</Link> and we'll be happy to assist you.
                </p>
              </div>

              {orderId && (
                <p className="text-muted mt-4 small">
                  Order Reference: {orderId}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default CheckoutCancel;
